import RejectWrapper from './RejectWrapper';

export default RejectWrapper;
